<template>
  <v-app>
    <div class="header-strip">
      <a :href="configStrings.clubWebsiteLink">
        <img src="./assets/efl.svg" height="80" width="250"  class="logo" />
      </a>
      <h1 style="display:none;">{{ configStrings.productName }}</h1>
    </div>
  
    <v-content v-if="redirectingInProgress">
      <v-layout row wrap>
        <v-flex xs12 sm4 offset-sm4 pt-5>
          <div class="loadingImage">
            Redirecting to partner platform
            <img
              src="./assets/loading.svg"
              height="88"
              width="88"
              class="loading"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-content>
    <v-content v-else>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from "vue";
//import Vuetify from 'vuetify'
import CognitoPlugin from "./cognito-plugin.js";
import GlobalConfig from "./globalConfig.js";
import VueCookie from "vue-cookie";

import Vuetify, {
  VApp, // required
  VAlert,
  VTabs,
  VTooltip,
} from "vuetify/lib";

import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VTabs,
    VTooltip,
  },
  directives: {
    Ripple,
  },
});

Vue.use(CognitoPlugin);
Vue.use(GlobalConfig);
Vue.use(VueCookie);
Vue.use(require("vue-moment"));

export default {
  name: "App",
  components: {
  },
  data() {
    return {
      loggedIn: false,
      referrer: null,
      showHeader: false,
      ticketingRedirect: null,
      redirectingInProgress: false,
      miniNavTicketingEnabled: false,
      officialWebsites: null,
    };
  },
  mounted() {
    console.log(window.location.href);
    //check if logout was requested
    if (window.location.href.includes("/partner/logout")) {
      this.$signOut();
      this.$router.push("/");
    }

    // simple referral tracking
    if (window.location.href.includes("referred=1")) {
      //if the user is referred from a partner site
      localStorage.referrer = document.referrer;
    }

    if (!window.location.href.includes("cross-site")) {
      //if the URL does not conatin cross-site
      this.showHeader = true;
    }

    var urlPieces = window.location.href.split("returnUrl=");
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = decodeURIComponent(urlPieces[1]); //we take the whole string after this param as it could itself contain params and we want to keep them
    const responseType = urlParams.get("responseType");
    const sendToken = urlParams.get("sendToken");
    console.log("returnUrl:", returnUrl);
    console.log("responseType:", responseType);
    console.log("sendToken:", sendToken);

    if (window.location.href.includes("returnUrl=")) {
      //if the user is referred from the StreamAMG payments site

      console.log("returnUrl requested");
      var trustedSource = false;
      this.getConfigTrustedDomains().forEach((domain) => {
        if (returnUrl.includes(domain)) {
          trustedSource = true;
          console.log(domain, "is trusted");
        }
      });

      if (trustedSource === true) {
        console.log("Trusted returnUrl set", returnUrl);
        localStorage.returnUrl = returnUrl;
        if (sendToken == "false") {
          localStorage.suppressToken = "true";
        } else {
          localStorage.removeItem("suppressToken");
        }
        if (responseType == "post") {
          localStorage.responseType = "post";
        } else {
          localStorage.responseType = "get";
        }
        console.log(
          "CHECKING FOR TM LOGIN",
          this.configValues.ticketMasterConfig.domain
        );
        if (
          this.configValues.ticketMasterAccountLinkingEnabled === true &&
          returnUrl.includes(this.configValues.ticketMasterConfig.domain)
        ) {
          localStorage.loginFlow = "TicketMaster";
        } else if (this.getPlatformRequiresAddress() === true) {
          localStorage.loginFlow = "AddressRequired";
        } else {
          localStorage.loginFlow = "Standard";
        }
      } else {
        console.log("returnUrl NOT from trusted domain");
      }
    } else {
      console.log("returnUrl NOT requested");
    }

    if (typeof localStorage.returnUrl != "undefined") {
      if (localStorage.returnUrl.includes("ticket")) {
        this.ticketingRedirect = localStorage.returnUrl;
      }
    }
    //Upon initial mount we check the authentication state
    console.log("Access Check", "route change");
    if (this.$getAuthenticatedUser() != null) {
      console.log("Access Check", "user authenticated");

      // If we detect a page load with a
      if (localStorage.returnUrl && localStorage.loginFlow == "TicketMaster") {
        console.log(
          "Ticketmaster Login Flow Detected (Already logged in to SSO)"
        );
        console.log("HELLO");
        //if not user client_ref record
        this.$getCurrentUserAttributes().subscribe((userData) => {
          if (userData["custom:client_ref_verified"] === "false") {
            console.log("TM user has not linked client ref");
            localStorage.loginFlow = "TicketMasterNoClientRef";
          } else {
            this.showRedirectMessage();
            this.ticketMasterRedirectWithToken();
          }
        });
      }

      if (localStorage.returnUrl && localStorage.loginFlow == "Standard") {
        console.log("Standard Login Flow Detected (Already logged in to SSO)");
        this.showRedirectMessage();
        this.performRedirect();
      }

      this.$getCurrentUserAttributes().subscribe(
        (userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log("Access Check", "checking registration is complete");
          // console.log('Access Check userDate', userData)

          var additionalRegistrationFields = ["address"];

          var proceed = true;

          if (this.configValues.accountRequestAddressOnFirstLogin === false) {
            // if the system is configured to not request address on first login we do nothing
          } else if ("custom:address_skip" in userData) {
            // if they've previously skipped adding their address then (for now) we do nothing
          } else {
            // otherwise we do a check that they have populated their address yet
            additionalRegistrationFields.forEach((element) => {
              if (element in userData) {
                console.log("Found additional key", element);
              } else {
                console.log("NOT found additional key", element);
                proceed = false;
              }
            });
          }

          if (window.location.href.includes("/auth/logout")) {
            // then we let it through to the logout page
          } else if (proceed === true) {
            console.log("Access Check", "All fields populated");
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there or the site is being accessed by a partner site
            if (this.showHeader === true) {
              if (this.$route.name != "profile") {
                this.$router.push("/profile");
              }
            }
          } else {
            console.log("Access Check", "additional fields NOT yet complete 1");
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }

          console.log("LOGGED IN ALL OK ");
          // Finally we generate the offical links list
          this.processOfficalWebsiteLinks();
        },
        (err) => {
          console.log(
            "Access Check",
            "Unable to load user profile, session may not be present."
          );
          this.loggedIn = false;
        }
      );
    } else {
      console.log("Access Check", "no authenticated user present");
      this.loggedIn = false;
    }
  },
  methods: {
    redirectToTicketing() {
      var redirectTo = localStorage.returnUrl;
      localStorage.returnUrl = "";
      window.location = redirectTo;
    },
    showRedirectMessage() {
      this.redirectingInProgress = true;
    },
    generateFinalURL(site) {
      if (typeof site.ticketMasterTokenLogin !== "undefined") {
        this.ticketMasterGenerateToken(false).then((generatedUrl) => {
          if (generatedUrl !== false) {
            console.log("Generated URL", generatedUrl);
            return generatedUrl;
          } else {
            return site.URL;
          }
        });
      } else {
        return site.URL;
      }
    },
    processOfficalWebsiteLinks() {
      this.officialWebsites = [];

      this.configOfficialWebsites.forEach((site) => {
        if (typeof site.ticketMasterTokenLogin !== "undefined") {
          this.ticketMasterGenerateToken(false).then((generatedUrl) => {
            console.log("Generated URL", generatedUrl);
            if (generatedUrl !== false) {
              site.URL = generatedUrl;
            }
            this.officialWebsites.push(site);
          });
        } else {
          this.officialWebsites.push(site);
        }
      });
    },
  },
  watch: {
    $route(to) {
      //Upon each route change we check the authentication state

      console.log("Access Check", "route change");
      if (this.$getAuthenticatedUser() != null) {
        console.log("Access Check", "user authenticated");
        this.$getCurrentUserAttributes().subscribe(
          (userData) => {
            //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
            console.log("Access Check", "checking registration is complete");
            // console.log('Access Check userDate', userData)

            var additionalRegistrationFields = ["address"];

            var proceed = true;

            if (this.configValues.accountRequestAddressOnFirstLogin === false) {
              // if the system is configured to not request address on first login we do nothing
            } else if ("custom:address_skip" in userData) {
              // if they've previously skipped adding their address then (for now) we do nothing
            } else {
              // otherwise we do a check that they have populated their address yet
              additionalRegistrationFields.forEach((element) => {
                if (element in userData) {
                  console.log("Found additional key", element);
                  if (element === "address") {
                    // Sometimes clubs set country in registration so we need to check first line
                    console.log("TYPEOF address", typeof userData.address);
                    if (!userData.address.includes("street_address")) {
                      proceed = false;
                    }
                  }
                } else {
                  console.log("NOT found additional key", element);
                  proceed = false;
                }
              });
            }

            if (window.location.href.includes("/auth/logout")) {
              // then we let it through to the logout page
            } else if (proceed === true) {
              console.log(
                "Access Check",
                "All fields populated",
                this.$route.name
              );
              this.loggedIn = true;
              //always force logged in users to their profile, unless they are already going there
              if (this.$route.name != "profile") {
                this.$router.push("/profile");
              }
            } else {
              console.log(
                "Access Check",
                "additional fields NOT yet complete 2"
              );
              this.loggedIn = false;
              this.$router.push("/complete-registration");
            }
          },
          (err) => {
            console.log(
              "Access Check",
              "Unable to load user profile, session may not be present."
            );
            this.loggedIn = false;
          }
        );
      } else {
        console.log("Access Check", "no authenticated user present");
        this.loggedIn = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "/css/global.scss";
</style>

<style lang="scss" scoped>


.header-strip {
  width: 100%;
  color: #fff;
  background-color: $primary-club;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 10px 25px 5px 25px;
  margin-bottom: 20px;
}

.header-strip img {
  display: inline;
}

.header-strip h1 {
  display: inline;
  margin-left: 20px;
  font-size: 1.5em;
}

.user-info-container {
  margin: 20px 0 0;
}
.cross-site-container {
  margin: 20px 0 0;
}

.button-home {
  display: none;
}


.mini-nav {
  width: 250px;
}
.mini-nav li {
  list-style: none;
}
.web-link {
  padding: 0;
  margin: 0 2px 0 0;
  color: $primary-club;
  font-size: 12px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
.page-title {
  color: $primary-club;
  font-size: 44px;
  text-align: left;
}
.loadingImage img {
  display: block;
  margin: auto;
}
</style>
